import { Injectable } from '@angular/core';
import { AppSettingsBase } from '../config/app-settings-base';
import { Platform, Events } from 'ionic-angular';
import { EventCodes } from '../core/codes';
import { AngularFireDatabaseWrapper } from '../providers/angularfire-wrapper';

@Injectable()
export class AppSettings extends AppSettingsBase{
	public isLoaded:boolean = false;
	constructor(
		private events: Events,
		private platform: Platform,
		private afw: AngularFireDatabaseWrapper 
		){
		super();
	}

	public getData(){
		let self = this;
		let strgRef = '/app-options/';
		return  self.afw.object(strgRef,undefined, true).map(data=>{
			self.populateData(data);
			return data;
		});
	}

  	private populateData(data){
  		this.appName = data.appName;
  		this.activePlugins = data.activePlugins;
  		this.adminEmail = data.adminEmail;
  		this.adminURL = data.adminURL;
  		this.appURL = data.appURL;
  		this.webURL = data.webURL;
  		this.commentsPerPage = data.commentsPerPage;
  		this.postsPerPage = data.postsPerPage;
  		this.briefMaxChar = data.briefMaxChar;
  		this.feedImageDirectory = data.feedImageDirectory;
  		this.largeSizeH = data.largeSizeH;
  		this.largeSizeW = data.largeSizeW;
  		this.mediumSizeH = data.mediumSizeH;
  		this.mediumSizeW = data.mediumSizeW;
  		this.thumbSizeH = data.thumbSizeH;
  		this.thumbSizeW = data.thumbSizeW;
  		this.piwikSiteId = data.piwikSiteId;
  		this.piwikURL = data.piwikURL;
  		this.paypalKey = data.paypalKeyDev;
		this.appUpdateMessage = data.appUpdateMessage;
		this.requireLogin = data.requireLogin;
		this.topMenuLocation = data.topMenuLocation;
		this.bottomMenu = data.bottomMenu;
		this.allowSignUp = data.allowSignUp;
		this.appLogo = data.appLogo;
		this.homePage = data.homePage;
		this.feedPostMaxChar = data.feedPostMaxChar;
		this.membershipApplicationImageDirectory = data.membershipApplicationImageDirectory;
		this.membershipApplicationPaymentImageDirectory = data.membershipApplicationPaymentImageDirectory;
		this.TLSAPIDefaultToken = data.TLSAPIDefaultToken;
		this.TLSAPIKey = data.TLSAPIKey;
		this.TLSAPISource = data.TLSAPISource;
		this.TLSAPIUserName = data.TLSAPIUserName;
		this.TLSAPIPassword = data.TLSAPIPassword;
		this.TLSAPIUrl = data.TLSAPIUrl;
		this.TLSAPITestMode = data.TLSAPITestMode;
		this.TLSCacheTimestamp = data.TLSCacheTimestamp;
		this.elasticSearch = data.elasticSearch;
		this.gMapCenterPointsDefault = data.gMapCenterPointsDefault;
		this.gMapRadius = data.gMapRadius;
		this.gMapZoom = data.gMapZoom;
		this.geoCodeUrl = data.geoCodeUrl;
		this.isLoaded = true;

		if(this.platform.is('ios')){
			// console.log("Detected Platform IOS");
			// console.log(data.iosBuildVersion +'-' + this.iosBuildVersion);
	  		this.requireAppUpdate = data.iosBuildVersion > this.iosBuildVersion;
	  		// console.log("require update, ", this.requireAppUpdate);
	  		this.appDownloadURL = data.iosDownloadURL;
	  	} else if (this.platform.is('android')){
	  		// console.log("Detected Platform Android");
	  		this.requireAppUpdate = data.androidBuildVersion > this.androidBuildVersion;
	  		this.appDownloadURL = data.androidDownloadURL;
	  	}

		this.events.publish(EventCodes.APPSETTINGS_LOADED, this);
  	}
}


// WEBPACK FOOTER //
// ./src/config/app-settings.ts